export default {
	app_id: 'farhanhm12_gmail_com_f5a827',
	app_key: '400063a44919e11449eb',
	'Content-type': 'application/json'
};
